import type { ReactNode } from "react";
import { cx } from "../utils/cx";
import styles from "./Panel.module.css";

interface CardProps {
  className?: string;
  children: ReactNode;
}

/**
 * A repeatable content unit within a panel, grid, or list (style-guide.md:
 * Panels and Cards). Uses --surface-alt so it separates from a panel's
 * --surface. Do not nest surfaces deeper than bg → surface → surface-alt.
 */
function Card({ className, children }: CardProps) {
  return <div className={cx(styles.card, className)}>{children}</div>;
}

export default Card;
